module.exports = __webpack_public_path__ + "static/img/0542_2.a13fd10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0542_2.jpg
// module id = ZUBZ
// module chunks = 1